var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVandpost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#0072bc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.362,10.075a5.969,5.969,0,0,1-.446.66,2.226,2.226,0,0,0-.587,1.19A1.084,1.084,0,0,0,4.362,13.05,1.083,1.083,0,0,0,5.4,11.925a2.231,2.231,0,0,0-.586-1.19A5.978,5.978,0,0,1,4.362,10.075Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.27,4.287h-.943a.511.511,0,0,0-.51.51v.085H9.093V4.517a.135.135,0,0,0-.135-.135H8.551V3.7A.622.622,0,0,0,8.643,3.6l1.236.127a.539.539,0,0,0,.421-.937.536.536,0,0,0-.421-.133l-1.236.127a.655.655,0,0,0-1.025,0L6.382,2.661a.538.538,0,0,0-.42.937.543.543,0,0,0,.42.133L7.618,3.6A.735.735,0,0,0,7.71,3.7v.685H7.3a.136.136,0,0,0-.136.135v.365H6.487a3.094,3.094,0,0,0-3.1,3.1v.076H3.32a.136.136,0,0,0-.135.135V9.218a.135.135,0,0,0,.135.135H5.433a.134.134,0,0,0,.135-.135V8.192a.135.135,0,0,0-.135-.135H5.365V7.981A1.124,1.124,0,0,1,6.487,6.858h.355a1.493,1.493,0,0,0,.5.521,1.479,1.479,0,0,0,1.584,0,1.491,1.491,0,0,0,.5-.521h1.4v.085a.511.511,0,0,0,.51.51h.943a.136.136,0,0,0,.136-.135V4.423A.136.136,0,0,0,12.27,4.287Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVandpost);
export default __webpack_public_path__ + "static/media/VANDPOST.e581bf5684f6a4d0989eb49352bbcfc4.svg";
export { ForwardRef as ReactComponent };